import { Typography } from '@mui/material';

import Number from 'src/components/common/Number';
import type { TextTypos } from 'src/types/theme';
import { gt } from 'src/utils/number';

import { Container } from './styled';

type DefaultNumberProps = {
  children?: string;
  typoOfIntegers?: keyof TextTypos;
  typoOfDecimals?: keyof TextTypos;
  fixed?: number;
  defaultValue?: string;
};

export default function DefaultNumber({ children, typoOfIntegers = 'h3', typoOfDecimals = 'h4', fixed, defaultValue = '0.000001' }: DefaultNumberProps) {
  return gt(children || '0', '0') ? (
    gt(children || '0', defaultValue) ? (
      <Number typoOfIntegers={typoOfIntegers} typoOfDecimals={typoOfDecimals} fixed={fixed}>
        {children}
      </Number>
    ) : (
      <Container>
        <Number typoOfIntegers={typoOfIntegers} typoOfDecimals={typoOfDecimals}>
          {`< ${defaultValue}`}
        </Number>
      </Container>
    )
  ) : (
    <Typography variant={typoOfIntegers}>0</Typography>
  );
}
